import React from 'react';
import Modal, { useModal } from '../../Components/Modal';
import { useBalance } from '../../Data/Balance';
import Form, { Actions, RequiredValidator, TextField } from '../../Components/Form';

const AddVoucher = ({isOpen, setIsOpen, onComplete}) => {
    return <Modal isOpen={isOpen} setIsOpen={setIsOpen} title="Add voucher" dismissible>
        {isOpen && <Inner {...{onComplete}} />}
    </Modal>
}

const Inner = ({onComplete}) => {
    const {closeModal} = useModal();
    const {redeemVoucher} = useBalance();

    const handlePurchase = async (data) => {
        await redeemVoucher(data.voucherCode);
        onComplete && onComplete();
        closeModal();
    }

    return <Form onSubmit={handlePurchase}>
        <TextField name="voucherCode" label="Voucher code" validators={[RequiredValidator]} />
        <Actions submit={{label: 'Add voucher'}} cancel />
    </Form>
    
}

export default AddVoucher;